<script lang="ts" setup>
import { type Client } from '@/stores/setting/DeviceActivity'
import type { BrowserIcon } from '@/composables/useBrowserIcon'
import { useTimestampDateFormat } from '@/composables/userDateFormat'

interface Props {
    title: string
    ipAddress: string
    lastAccess: number
    clients: Client[]
    started: number
    expires: number
    browserIcon: BrowserIcon
    current?: boolean
}

const props = defineProps<Props>()

/**
 * Date format
 *
 * @param timestamp
 */
function timestampDateFormat(timestamp: number) {
    return useTimestampDateFormat(timestamp, 'MMM DD, YYYY [at] HH:mm A')
}
</script>

<template>
    <el-descriptions direction="vertical">
        <template #title>
            <el-space>
                {{ props.title }}
                <img width="14" height="14" :src="browserIcon.url" :alt="browserIcon.alt" />
                <el-tag v-if="props.current" class="ms-1" type="success" disable-transitions round>
                    {{ $t('settings.currentSession') }}
                </el-tag>
            </el-space>
        </template>
        <el-descriptions-item :label="$t('settings.ipAddress')">
            {{ props.ipAddress }}
        </el-descriptions-item>
        <el-descriptions-item :label="$t('settings.lastAccessed')">
            {{ timestampDateFormat(props.lastAccess) }}
        </el-descriptions-item>
        <el-descriptions-item :label="$t('settings.clients')">
            <template v-for="(client, index) in props.clients" :key="index">
                {{ client.clientId
                }}<span v-if="props.clients.length > 0 && props.clients.length - 1 != index"
                    >,
                </span>
            </template>
        </el-descriptions-item>
        <el-descriptions-item :label="$t('settings.started')">
            {{ timestampDateFormat(props.started) }}
        </el-descriptions-item>
        <el-descriptions-item :label="$t('settings.expires')">
            {{ timestampDateFormat(props.expires) }}
        </el-descriptions-item>
    </el-descriptions>
</template>

<style lang="scss">
th {
    padding-bottom: 0 !important;
    font-weight: 600 !important;
}
</style>
